import * as SignalR from "@microsoft/signalr";
import { mapIncoming } from "infrastructure/mapping/Mapping";
import { Dispatch } from "redux";
import { FuelStopActionType } from "redux/actions/machines/FuelStopActions";
import { MachineDefectActionType } from "redux/actions/machines/MachineDefectActions";
import { MachineHistoryActionType } from "redux/actions/machines/MachineHistoryActions";
import { FuelTypeActionType } from "redux/actions/settings/FuelTypeActions";
import { MachineActionType } from "redux/actions/settings/MachineActions";
import { MachineMaintenanceActionType } from "redux/actions/settings/MachineMaintenanceActions";
import { MachinePartActionType } from "redux/actions/settings/MachinePartActions";
import { MachineTypeActionType } from "redux/actions/settings/MachineTypeActions";
import { MaintenanceActionType } from "redux/actions/settings/MaintenanceActions";
import { ManufacturerActionType } from "redux/actions/settings/ManufacturerActions";
import { UserActionType } from "redux/actions/settings/UserActions";
import { signalRUrl } from "global"
import { LoginUserActionType } from "redux/actions/LoginUserActions";
import { UnitActionType } from "redux/actions/settings/UnitActions";
import { UserTaskActionType } from "redux/actions/UserTaskActions";

let connection: SignalR.HubConnection;
let activeToken: string = "";
let propDispatch: Dispatch;

function buildConnection(token: string) {
    return new SignalR.HubConnectionBuilder()
        .withUrl(signalRUrl, { accessTokenFactory: () => { return token } })
        .withAutomaticReconnect()
        .configureLogging(SignalR.LogLevel.Trace)
        .build();
}

export class SignalRReiceiver {
    
    constructor(token: string, dispatch: Dispatch) {
        connection = buildConnection(token);
        activeToken = token;
        propDispatch = dispatch;
        this.startConnection = this.startConnection.bind(this);
        this.setReceivers = this.setReceivers.bind(this);
    };

    startConnection(token: string) {
        if (activeToken !== token) {
            console.log("Setting new JWT Token");
            connection.stop();
            connection = buildConnection(token);
            activeToken = token;
        }
        console.log("Trying to start signalR");
        connection.start().then(this.setReceivers, (e) => this.handleError(e));
    }

    handleError(e: SignalR.HttpError) {
        console.log(e.message);
        if (e.statusCode === 401) { // discard remaining token if invalid
            propDispatch({
                type: LoginUserActionType.LOGOFF_USER,
                token: ''
            })
        }
    }

    stopConnection() {
        return connection.stop();
    }

    isConnected() {
        return connection.state === SignalR.HubConnectionState.Connected;
    }

    getConnectionState() {
        return connection.state;
    }

    setReceivers() {
        this.setActionReceiver(FuelStopActionType.ADD_FUELSTOP_SUCCESS);
        this.setActionReceiver(FuelStopActionType.EDIT_FUELSTOP_SUCCESS);
        this.setActionReceiver(FuelStopActionType.DELETE_FUELSTOP_SUCCESS);
        
        this.setActionReceiver(FuelTypeActionType.ADD_FUELTYPE_SUCCESS);
        this.setActionReceiver(FuelTypeActionType.EDIT_FUELTYPE_SUCCESS);
        this.setActionReceiver(FuelTypeActionType.DELETE_FUELTYPE_SUCCESS);

        this.setActionReceiver(MachineActionType.ADD_MACHINE_SUCCESS);
        this.setActionReceiver(MachineActionType.EDIT_MACHINE_SUCCESS);
        this.setActionReceiver(MachineActionType.DELETE_MACHINE_SUCCESS);

        this.setActionReceiver(MachineDefectActionType.ADD_MACHINEDEFECT_SUCCESS);
        this.setActionReceiver(MachineDefectActionType.EDIT_MACHINEDEFECT_SUCCESS);
        this.setActionReceiver(MachineDefectActionType.DELETE_MACHINEDEFECT_SUCCESS);

        this.setActionReceiver(MachineHistoryActionType.ADD_MACHINEHISTORY_SUCCESS);
        this.setActionReceiver(MachineHistoryActionType.EDIT_MACHINEHISTORY_SUCCESS);
        this.setActionReceiver(MachineHistoryActionType.DELETE_MACHINEHISTORY_SUCCESS);

        this.setActionReceiver(MachineMaintenanceActionType.ADD_MACHINEMAINTENANCE_SUCCESS);
        this.setActionReceiver(MachineMaintenanceActionType.EDIT_MACHINEMAINTENANCE_SUCCESS);
        this.setActionReceiver(MachineMaintenanceActionType.DELETE_MACHINEMAINTENANCE_SUCCESS);

        this.setActionReceiver(MachineTypeActionType.ADD_MACHINETYPE_SUCCESS);
        this.setActionReceiver(MachineTypeActionType.EDIT_MACHINETYPE_SUCCESS);
        this.setActionReceiver(MachineTypeActionType.DELETE_MACHINETYPE_SUCCESS);

        this.setActionReceiver(MaintenanceActionType.ADD_MAINTENANCE_SUCCESS);
        this.setActionReceiver(MaintenanceActionType.EDIT_MAINTENANCE_SUCCESS);
        this.setActionReceiver(MaintenanceActionType.DELETE_MAINTENANCE_SUCCESS);

        this.setActionReceiver(MachinePartActionType.ADD_MACHINEPART_SUCCESS);
        this.setActionReceiver(MachinePartActionType.EDIT_MACHINEPART_SUCCESS);
        this.setActionReceiver(MachinePartActionType.DELETE_MACHINEPART_SUCCESS);

        this.setActionReceiver(ManufacturerActionType.ADD_MANUFACTURER_SUCCESS);
        this.setActionReceiver(ManufacturerActionType.EDIT_MANUFACTURER_SUCCESS);
        this.setActionReceiver(ManufacturerActionType.DELETE_MANUFACTURER_SUCCESS);

        this.setActionReceiver(UnitActionType.ADD_UNIT_SUCCESS);
        this.setActionReceiver(UnitActionType.EDIT_UNIT_SUCCESS);
        this.setActionReceiver(UnitActionType.DELETE_UNIT_SUCCESS);

        this.setActionReceiver(UserActionType.ADD_USER_SUCCESS);
        this.setActionReceiver(UserActionType.EDIT_USER_SUCCESS);
        this.setActionReceiver(UserActionType.DELETE_USER_SUCCESS);
        this.setActionReceiver(UserActionType.ADD_ROLE_SUCCESS);
        this.setActionReceiver(UserActionType.REMOVE_ROLE_SUCCESS);

        this.setActionReceiver(UserTaskActionType.ADD_USERTASK_SUCCESS);
        this.setActionReceiver(UserTaskActionType.EDIT_USERTASK_SUCCESS);
        this.setActionReceiver(UserTaskActionType.DELETE_USERTASK_SUCCESS);
    }

    setActionReceiver(actionType: string) {
        connection.on(actionType, data => {
            propDispatch({
                type: actionType,
                ...mapIncoming(actionType, data)
            })
        });
        
    }

}